import { render } from "./BaseSelect.vue?vue&type=template&id=a964ccf2"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script